import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { UserRole } from "../../features/access-rights/user-roles";
import { ProtectedMode, RoleProtectedAction } from "./role-protected-action";
export const WriteAccessAction = ({ children }) => {
    const { t } = useTranslation();
    return (_jsx(RoleProtectedAction, { allowedRoles: [UserRole.ADMIN, UserRole.OPERATOR], mode: ProtectedMode.DISABLE, reason: t("user.access.disabled"), children: children }));
};
